import { ReactNode } from "react";
import { cn } from "@/lib/utils";
interface ContainerProps {
  children: ReactNode;
  as?: "div" | "main";
  className?: string;
}
export const Container = ({
  children,
  as = "div",
  className
}: ContainerProps) => {
  const Component = as;
  return <Component className={cn("mx-auto w-full max-w-7xl grow px-4 sm:px-6 lg:px-8", as === "main" ? "pb-32 pt-6" : "", className)} data-sentry-element="Component" data-sentry-component="Container" data-sentry-source-file="container.tsx">
      {children}
    </Component>;
};